export interface PetugasRm {
  id: string | number;
  nama: string;
  ppds?: string | null;
}

export function ppdsText(
  petugas?: { ppds?: string | null } | null
): string | null {
  const teks = petugas && typeof petugas.ppds === "string" ? petugas.ppds.trim() : "";
  return teks !== "" ? teks : null;
}
